import { Record } from 'immutable';
const TransientReservationSearchParametersRecord = Record({
  eventId: null,
  firstName: null,
  lastName: null,
  minCheckInDate: null,
  maxCheckOutDate: null
});

export class TransientReservationSearchParameters extends TransientReservationSearchParametersRecord {
  eventId: number;
  firstName: string;
  lastName: string;
  minCheckInDate: string;
  maxCheckOutDate: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/transient-reservation-search-params.ts